/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import BaseComponent from '../../../panther/components/base/BaseComponent';

import Button from '../../../panther/components/atoms/Button/Button.js';

import styles from './MicrositeModal.css';

class MicrositeModal extends BaseComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let title = this.renderTitle();
        let body = this.renderBody();
        let footer = this.renderFooter();

        return (
            <Modal
                show={this.props.open}
                onHide={this.props.onClose}
                className="microsite-modal"
            >
                {title}
                {body}
                {footer}
            </Modal>
        );
    }

    renderBody(){
        let content = [];

        this.props.data.content.map((part, index) => {
            if (typeof part === 'object'){
                if (part.title){
                    content.push(<h4 className="modal-section-title">{part.title}</h4>);
                }
                if (part.text){
                    content.push(<p>{part.text}</p>);
                }
                if (part.image){
                    let cls = "modal-image";
                    if (part.image.className){
                        cls += " " + part.image.className;
                    }

                    content.push(<img className={cls} alt={part.image.title} src={require("../../../resources/img/" + part.image.source)}/>);
                    content.push(<span className="modal-image-title">{part.image.title}</span>);
                }
                if (part.list){
                    content.push(<span>{part.list.title}</span>);

                    let listItems = [];
                    part.list.items.map(item => {
                        listItems.push(<li>{item}</li>);
                        return listItems;
                    });

                    content.push(<ul className="classic-list full-width">{listItems}</ul>);
                }
            } else {
                content.push(<p>{part}</p>);
            }
            return content;
        });

        return (
            <Modal.Body>
                {content}
            </Modal.Body>
        );
    }


    renderTitle(){
        return (
            <Modal.Header>
                <Modal.Title>{this.props.title}</Modal.Title>
            </Modal.Header>
        );
    }

    renderFooter(){
        return (
            <Modal.Footer>
                <Button
                    alignCenter
                    onClick={this.props.onClose}
                    className="w8"
                >
                    Close
                </Button>
            </Modal.Footer>
        );
    }
}

MicrositeModal.propTypes = {
    data: PropTypes.object,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string
};

export default MicrositeModal;